export enum ExtendedFieldsActions {
  NEW = "NEW",
  EDIT = "EDIT",
  DELETE = "DELETE",
}

export enum ExtendedFieldsSourceType {
  SP = "SP",
  VALUE = "VALUE",
}

export const EXTENDED_FIELD_DRAWER_DEFAULT = {
  id: -1,
  visible: false,
  title: "",
  type: ExtendedFieldsActions.NEW,
};

export const INITIAL_EXTENDED_FIELD_DETAIL = {
  id: -1,
  fieldName: "",
  fieldCategory: "",
  description: "",
  dataType: "",
  dataTypeId: undefined,
  valueList: [undefined],
  storedProcedure: undefined,
  valueType: ExtendedFieldsSourceType.SP,
};

export enum ExtendedFieldCategory {
  DEBTOR = "Debtor",
  CASE = "Case",
  AR = "AR",
}

export const EXTENDED_FIELD_CATEGORIES = [
  { label: ExtendedFieldCategory.DEBTOR, value: ExtendedFieldCategory.DEBTOR },
  { label: ExtendedFieldCategory.CASE, value: ExtendedFieldCategory.CASE },
  { label: ExtendedFieldCategory.AR, value: ExtendedFieldCategory.AR },
];
